import React from 'react';
import './RunningStrip.css';

const RunningStrip = () => {
  return (
    <div className="running-strip-container">
      <div className="running-strip">
        <div className="marquee-content">
          🚀 Welcome to ClickaLinks - Your Direct Advertising Platform! • 
          ⭐ Premium Advertising Spaces Available - Get Your Spot Now! • 
          💫 Limited Time Offer - Secure Your Advertising Square Today! • 
          🎯 Reach Thousands of Customers - Advertise with ClickaLinks! Follow three simple step, Step 1: select Ad campaign. Step 2: Entre business details & company Logo. Step 3: Pay for your campaign to go Live!
        </div>
      </div>
    </div>
  );
};

export default RunningStrip;